/* eslint-disable*/
import VueStoreService from './VueStoreService';

const ContainerService = {
  async getContainers(url = '', store) {
    var resp = await VueStoreService.get("containers" + url, store)
    return resp;
  },
  async getContainer(container_id, store) {
    var resp = await VueStoreService.get("containers/" + container_id, store)
    return resp;
  },
  async saveContainer(data, store) {
    var resp = await VueStoreService.post("containers", data, store)
    return resp;
  },
  async updateContainer(container_id, data, store) {
    var resp = await VueStoreService.patch("containers/" + container_id, data, store)
    return resp;
  },
  async deleteContainer(container_id, store) {
    var resp = await VueStoreService.delete("containers/" + container_id, store)
    return resp;
  },
  async getContainerItems(container_id, url = '', store) {
    var resp = await VueStoreService.get("containers/" + container_id + "/items" + url, store)
    return resp;
  },
  async deleteContainerItems(container_id, store) {
    var resp = await VueStoreService.delete("containers/" + container_id + "/items", store)
    return resp;
  },
  async uploadExcel(container_id, file, store) {
    const form = new FormData();
    form.append('file', file);
    var resp = await VueStoreService.postFile("containers/" + container_id + "/excel", form, store)
    return resp;
  },
  async validateContainer(container_id, data, store) {
    var resp = await VueStoreService.post("containers/" + container_id + "/validate", data, store)
    return resp;
  },
  async moveToInventory(data, store) {
    var resp = await VueStoreService.post("containers/move-to-inventory", data, store)
    return resp;
  },
  async moveToInventoryExcel(file, warehouse, fila, bloque, store) {
    const form = new FormData();
    form.append('file', file);
    form.append('warehouse', warehouse);
    form.append('fila', fila);
    form.append('bloque', bloque);
    var resp = await VueStoreService.postFile("containers/move-to-inventory/excel", form, store)
    return resp;
  },
  async getInventoryStock(url = '', store) {
    var resp = await VueStoreService.get("inventory-stock" + url, store)
    return resp;
  },
}

export default ContainerService;
